import React, {useEffect, useState} from 'react'
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../Images/no-data-found.webp";
import BottomMenu from "../../../layout/bottomMenu";
import Calculator from "../../../DistanceCalculator/Calculator";
import Moment from "moment/moment";

const DealerListing = ({
    getLead,
    leadList=[],
    match,
    getLeadFilter,
    leadFilter,
    history
}) => {

    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [filterInputList, setFilterInputList] = useState([{}])
    const [open, setOpen] = useState(false);
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [pageNo, setPage] = useState(1)

    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected+1)
        await getLead('dealer', val?.selected+1, '', filterInputList, window.localStorage.role_id)
        setIsLoading(false)
    };

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getLead('dealer', 1, '', [{}], window.localStorage.role_id)
            await getLeadFilter()
            setIsLoading(false)
        })()
    }, [])

    const handlePreviousUrl = () => {
        // localStorage.setItem('previous_url', previousPageUrl)
    }

    const handleFilter = async (key, value, stringValue = '') => {

        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    const handleSearch = async () => {
        if (searchValue === '') {
            return false
        }
        if(searchValue){

        }
        await getLead('dealer', 1, searchValue, filterInputList, window.localStorage.role_id)
    }

    const removeSearchFilter = async () => {
        delete window.localStorage.search_lead
        setIsLoading(true)
        await getLead('dealer', 1, '', [{}], window.localStorage.role_id)
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        setOpen(false)
        setIsLoading(true)
        await getLead('dealer', pageNo, '', filterInputList, window.localStorage.role_id)
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if(key !== ''){
            delete filterInputList[0][key]
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await getLead('dealer', pageNo, '', filterInputList, window.localStorage.role_id)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setFilterInputList([{}])
                setIsLoading(true)
                await getLead('dealer', pageNo, '',  [{}], window.localStorage.role_id)
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Lead List'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between ">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px ">
                                            <form className="form-inline mr-auto w-90 navbar-search">
                                                <div className="d-flex w-100">
                                                    <input type="text"
                                                           className="form-control bg-light border-0 small list-filter"
                                                           placeholder="Search Lead..." aria-label="Search"
                                                           aria-describedby="basic-addon2"
                                                           onChange={(e) => {
                                                               setSearchValue(e.target.value)
                                                           }}
                                                    />
                                                    <div className="remove-search-filter">
                                                        <i className="fa fa-times" aria-hidden="true" onClick={removeSearchFilter}></i>
                                                    </div>
                                                    <div className="btn-search">
                                                        <button className="btn btn-primary lh-32 border-left-tr-tb"
                                                                type="button"
                                                                onClick={(e) => handleSearch()}
                                                        >
                                                            <i className="fas fa-search fa-sm"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                        <div className="col-md-6 cs-pos">
                                            <button onClick={() => setOpen(!open)}
                                                    className="btn btn-sm btn-primary mr-1 btn-filter"
                                                    type="button"><i
                                                className="fa fa-filter lh-35 pd-3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Filter View */}
                                {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mb-4">
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterInputList[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform:"capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {val === 'status' ? parseInt(filterInputList[0][val]) === 1 ? " - Pending" : parseInt(filterInputList[0][val]) === 2 ? " - Approved" : "  - Rejected" : " - "+filterInputList[0][val] }
                                                                <i className="bi bi-x-circle" onClick={(e) => {handleRemoveFilter(val)}}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/* Filter View End*/}

                                <div className="row">
                                    {/*CARD START*/}
                                    {leadList && leadList?.data !== undefined && leadList?.data !== [] && leadList?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    {parseInt(val?.status) === 1 ?
                                                                        <div className="header-ui-item-opp"
                                                                             style={{backgroundColor: "#bea925"}}>
                                                                            Pending
                                                                        </div> : parseInt(val?.status) === 2 ?
                                                                            <div className="header-ui-item-opp">
                                                                                Approved
                                                                            </div> :
                                                                            <div className="header-ui-item-opp"
                                                                                 style={{backgroundColor: "#88130a"}}>
                                                                                Rejected
                                                                            </div>
                                                                    }
                                                                    <div className="row">
                                                                        <div className="col-10" style={{
                                                                            color: "#000",
                                                                            fontSize: "20px",
                                                                            textAlign: "left",
                                                                            paddingLeft: "20px"
                                                                        }}>
                                                                            <div className="d-flex">
                                                                                {/*{parseInt(val?.is_draft) === 1 &&*/}
                                                                                {/*    <div className="draft">D&nbsp;&nbsp;</div>*/}
                                                                                {/*}*/}
                                                                                {`${val?.account_name}${(val?.meta_data !== null && val?.meta_data[0] && val?.meta_data[0]?.onboarded_dealer_id) ? "("+val?.meta_data[0]?.onboarded_dealer_id+")" : ''}`}
                                                                                {/*<span*/}
                                                                                {/*    className="ac-type">*/}
                                                                                {/*    {val?.poc_name}*/}
                                                                                {/*</span>*/}
                                                                            </div>

                                                                        </div>
                                                                        {parseInt(val?.status) === 2 &&
                                                                            <div className="col-2">
                                                                                {/*TOGGLE*/}
                                                                                <div className="dropdown"
                                                                                     style={{"float": "right"}}>
                                                                                    <a
                                                                                        href={`edit-dealer/${val?.id}`}
                                                                                        className="btn btn-sm icon-btn"
                                                                                        type="button"
                                                                                    ><i className="fas fa-edit"></i>
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                    </div>
                                                                    {/*<div className="row list-view">*/}
                                                                    {/*    <div className="mb-flex">*/}
                                                                    {/*        <div*/}
                                                                    {/*            className="col-md-6 col-sm-6 no-wrap">*/}
                                                                    {/*            <i className="fa fa-user"*/}
                                                                    {/*               aria-hidden="true"></i>&nbsp;&nbsp; Poc Name*/}
                                                                    {/*        </div>*/}
                                                                    {/*        <div*/}
                                                                    {/*            className="col-md-6 col-sm-6">{val?.poc_name}</div>*/}
                                                                    {/*    </div>*/}
                                                                    {/*</div>*/}
                                                                    <div className="row list-view">
                                                                        {val?.meta_data !== null && val?.meta_data[0] && val?.meta_data[0]?.master_dealer_type &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-industry"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Dealer Name
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger" data-tooltip-id="1" title={val?.meta_data[0]?.master_dealer_type}>{val?.meta_data[0]?.master_dealer_type}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {val?.email !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-envelope"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Email
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger" data-tooltip-id="1" title={val?.email}>{val?.email}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {val?.number &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-telephone-fill"></i>&nbsp;&nbsp;Contact No.
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">{val?.number}</div>
                                                                            </div>
                                                                        }
                                                                        {val?.assignee_name &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-user"></i>&nbsp;&nbsp;Assignee To
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">{val?.assignee_name}</div>
                                                                            </div>
                                                                        }

                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-user"></i>&nbsp;&nbsp;Poc Name
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6">
                                                                                <span className="trigger" data-tooltip-id="1" title={val?.poc_name}>{val?.poc_name}</span>
                                                                            </div>
                                                                        </div>

                                                                        {val?.address &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-building"></i>&nbsp;&nbsp;Address
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6">
                                                                                    <span className="trigger" data-tooltip-id="1" title={val?.address}>{val?.address}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {leadList?.rh_name && parseInt(val?.status) === 1 &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-user"></i>&nbsp;&nbsp;Action Pending By
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={leadList?.rh_name}>{leadList?.rh_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {val?.action_taken_by && parseInt(val?.status) === 2 &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-user"></i>&nbsp;&nbsp;Action Taken By
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6">
                                                                                    <span className="trigger" data-tooltip-id="1" title={val?.action_taken_by}>{val?.action_taken_by}</span>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                        {val?.updated_at && parseInt(val?.status) === 2 &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-calendar"></i>&nbsp;&nbsp;Action
                                                                                    Taken on
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">{Moment(val?.updated_at).format('DD-MM-YYYY')}
                                                                            </div>
                                                                            </div>
                                                                        }
                                                                        {val?.remark &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-comment"></i>&nbsp;&nbsp;Remark
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6">
                                                                                    <span className="trigger" data-tooltip-id="1" title={val?.remark}>{val?.remark}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                    <hr/>
                                                                    {parseInt(val?.status) === 2 &&
                                                                        <div className="row list-view-links">
                                                                            <ul>
                                                                                <li><a
                                                                                    href={`address-update-logs/${val?.id}`}
                                                                                    onClick={handlePreviousUrl}>
                                                                                    <i className="fa fa-tasks mr-2"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Address Logs</a>
                                                                                </li>
                                                                                <li><a
                                                                                    href={`dealer-lead-activity-list/${val?.id}`}
                                                                                    onClick={handlePreviousUrl}>
                                                                                    <i className="fa fa-tasks"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Activity</a>
                                                                                </li>
                                                                            </ul>
                                                                        </div>
                                                                    }


                                                                </h6>
                                                                <div className="col-sm-6">
                                                                    <a href={`dealer`}
                                                                       className="draft-float">
                                                                        <p className="my-float"
                                                                           style={{marginTop: "20px"}}><i
                                                                            className="fa fa-plus"
                                                                            aria-hidden="true"></i></p>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}
                                    {leadList && leadList?.data !== undefined && leadList?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(leadList?.total/leadList?.per_page)}
                                                forcePage={leadList?.current_page-1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }
                                    {leadList  && leadList?.data !== undefined &&  leadList?.data.length === 0  &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" alt={""}/>
                                            <div className="text-center" style={{"width":"100%"}}>
                                                Data Not Found
                                            </div>
                                            <div className="col-sm-6">
                                                <a href={`dealer`}
                                                   className="draft-float">
                                                    <p className="my-float" style={{marginTop:"20px"}}><i
                                                        className="fa fa-plus"
                                                        aria-hidden="true"></i></p>
                                                </a>
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent={leadFilter}
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
            {/* section ends */}
        </>
    )
}

export default DealerListing